module.exports = __webpack_public_path__ + "img/Avatar-02.71d4349f.svg";